import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function getUnformattedValue(value: string, delimiter = ","): number {
    return Number(value.replace(new RegExp(`\\${delimiter}`, "g"), ""));
  }

  return {
    getUnformattedValue,
  };
}
